import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fr } from "date-fns/locale";
import moment from "moment";

import MDBox from "../../../components/MDBox";
import MDInput from "../../../components/MDInput";
import MDTypography from "../../../components/MDTypography";

import { setAllOrganisms } from "../../../redux/reducers/organismsReducer";
import { useDispatch, useSelector } from "react-redux";

import { getOrganisms } from "../../../api/organisms";
import { useEffect } from "react";

export default function Control({
  deviceId,
  declarationFilename,
  setDeclarationFilename,
  ceDate,
  setCeDate,
  ceOrganismId,
  setCeOrganismId,
}) {
  const dispatch = useDispatch();

  async function fetchOrganisms() {
    const response = await getOrganisms();
    const formatedOrganisms = await response.data.map((organism) => ({
      label: organism.organism_name,
      id: organism.organism_id,
    }));
    dispatch(setAllOrganisms(formatedOrganisms));
  }

  const allOrganisms = useSelector((state) => state.organisms.allOrganisms);

  useEffect(() => {
    fetchOrganisms();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={6}>
          <Stack component="form" sx={{ width: "100%" }} noValidate>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
              <DatePicker
                slotProps={{ field: { clearable: true } }}
                displayWeekNumber
                label="Date du contrôle CE"
                value={ceDate && new Date(ceDate)}
                onChange={(newValue) => {
                  if (newValue === null) {
                    setCeDate(null);
                  } else setCeDate(moment(newValue).format("YYYY-MM-DD"));
                }}
                renderInput={(params) => <TextField {...params} fullWidth />}
                format="dd/MM/yyyy"
              />
            </LocalizationProvider>
          </Stack>
        </Grid>
        <Grid item xs={12} lg={6}>
          <Autocomplete
            sx={{ width: "100%" }}
            options={allOrganisms}
            value={ceOrganismId}
            onChange={(event, newCeOrganismId) => {
              setCeOrganismId(newCeOrganismId);
            }}
            renderInput={(params) => (
              <MDInput
                {...params}
                label="Organisme ayant réalisé le contrôle CE"
                variant="standard"
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sx={{ textAlign: "center" }}>
          <MDTypography variant="body3">
            Vous pouvez ajouter le fichier du contrôle CE directement depuis le tableau 🙂
          </MDTypography>
        </Grid>
      </Grid>
    </MDBox>
  );
}
